import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  entity_name: {
    name: 'Dominant influence company name'
  },
  entity_identification_lei: {
    name: 'Dominant influence company LEI code'
  },
  entity_identification_bic: {
    name: 'Dominant influence company BIC code '
  },

  transaction_type: {
    name: 'Transaction type'
  },
  other_transaction_type_description: {
    name: 'Description of other transaction type'
  },
  voting_rights_rate: {
    name: '% Voting rights'
  }
};

export function DominantInfluences({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.DOMINANT_INFLUENCES,
    onChangeFund,
    schema: schema.DOMINANT_INFLUENCES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.DOMINANT_INFLUENCES?.field_names || [],
    tableName: 'DOMINANT_INFLUENCES',
    funds,
    isMultiFunds,
    columnLables,
    // @ts-ignore
    order: 131,
    onAddColumn,
    onDeleteColumn,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-dominant-influences-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
